const route = {
	path: '/profile',
	name: 'profile',
	meta: {
		noChangeCompany: true,
		title: 'Mi perfil',
	},
	component: () => import('@/pages/profile/page-profile'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/profile.js